import { Breadcrumb } from "antd";
import { BackButton } from "../../../../Components/Utils/Buttons";
import IndexBidding from "./Activity/Index";

const MainBiddingSettings = () =>{
    return(
      <div className='w-full h-full px-4 py-2'>
        <div className='w-full flex justify-between items-center'>
        <Breadcrumb
          items={[
            {
              name: "Settings",
            },
            {
              name: "Bidding"
            }
          ]}
        />
        <BackButton/>
        </div>
        <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-scroll">
              <div className="p-3"><IndexBidding/></div>
            
        </div>
        </div>
    )
  }

  export default MainBiddingSettings;